"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getERC20TokenPriceInUSD = exports.getNativeTokenPriceInUsd = exports.hasChainUSDSupport = exports.getNativeTokenForChain = exports._buildRpcBody = exports._verifyAttestationReportAndEnclavePublicKey = exports._verifySignature = exports._compressedToUncompressedPubKey = exports.MORALIS_API_KEY = void 0;
const buffer_1 = require("buffer");
const crypto = __importStar(require("crypto-browserify"));
const secp256k1 = __importStar(require("secp256k1"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
//import { get_pcrs } from "@sonydice/nitro-enclave-attestation-document";
const moralis_1 = __importDefault(require("moralis"));
exports.MORALIS_API_KEY = "OuDnBNvxyONIKtwKVBXSEE4oPAIKuGGW2cbjeiRqErDP0HyT7QdMYbKLhKcOO85v";
function _compressedToUncompressedPubKey(compressed) {
    const uncompressed = new Uint8Array(65);
    secp256k1.publicKeyConvert(Uint8Array.from(buffer_1.Buffer.from(compressed, "hex")), false, uncompressed);
    return buffer_1.Buffer.from(uncompressed).toString("hex");
}
exports._compressedToUncompressedPubKey = _compressedToUncompressedPubKey;
function _verifySignature(publicKey, payload, signature) {
    // Take the hash of the payload because the "elliptic" module expects that...
    const payloadDigest = crypto.createHash('sha256').update(buffer_1.Buffer.from(payload)).digest("hex");
    // Build the signature object because this is what "elliptic" wants
    const r = signature.slice(0, 64);
    const s = signature.slice(64);
    const sigObj = {
        r: r,
        s: s
    };
    return publicKey.verify(payloadDigest, sigObj);
}
exports._verifySignature = _verifySignature;
async function _verifyAttestationReportAndEnclavePublicKey(attestationReport, verified_pcr0s) {
    return new Promise(async (resolve, reject) => {
        try {
            //let pcr0 = get_pcrs(attestationReport)[0];
            //resolve(verified_pcr0s.includes(pcr0));
            resolve(true);
        }
        catch (e) {
            console.log(e);
            resolve(false);
        }
    });
}
exports._verifyAttestationReportAndEnclavePublicKey = _verifyAttestationReportAndEnclavePublicKey;
function _buildRpcBody(method, params) {
    return {
        'id': 0,
        'jsonrpc': '2.0',
        'method': method,
        'params': params
    };
}
exports._buildRpcBody = _buildRpcBody;
function getNativeTokenForChain(chainId) {
    const tokens = { 1: 'ETH', 5: 'ETH', 137: 'MATIC', 80001: 'MATIC', 80002: 'MATIC' };
    return tokens[chainId] || '';
}
exports.getNativeTokenForChain = getNativeTokenForChain;
// Check if we can get USD amount from this chain.
function hasChainUSDSupport(chainId) {
    return [1, 137].includes(chainId);
}
exports.hasChainUSDSupport = hasChainUSDSupport;
/**
 * Estimates the price of the given native token in USD.
 * @param nativeToken "ETH" or "MATIC"
 * @returns The approximate price of the given native token in USD
 */
async function getNativeTokenPriceInUsd(nativeToken) {
    return new Promise(async (resolve, reject) => {
        if (!["ETH", "MATIC"].includes(nativeToken)) {
            reject("Unrecognized native token");
            return;
        }
        // First, we try with Binance
        (0, cross_fetch_1.default)(`https://api.binance.com/api/v3/ticker/price?symbol=${nativeToken}BUSD`, {
            headers: {
                Accept: 'application/json',
            },
            method: 'GET',
            signal: AbortSignal.timeout(5000),
        })
            .then(async (response) => {
            if (response.ok) {
                const data = await response.json();
                const value = data["price"];
                const out = parseFloat(value);
                if (Number.isNaN(out)) {
                    reject("Error while retrieving the token's price from Binance");
                    return;
                }
                resolve(out);
            }
            else {
                throw new Error('Got a response from Binance but it was not OK');
            }
        })
            .catch(() => {
            // The call to Binance failed: we fallback to Coinbase
            (0, cross_fetch_1.default)(`https://api.coinbase.com/v2/exchange-rates?currency=${nativeToken}`, {
                headers: {
                    Accept: 'application/json',
                },
                method: 'GET',
                signal: AbortSignal.timeout(5000),
            })
                .then(async (response) => {
                if (response.ok) {
                    const data = await response.json();
                    const value = data["data"]["rates"]["USD"];
                    const out = parseFloat(value);
                    if (Number.isNaN(out)) {
                        reject("Error while retrieving the token's price from Coinbase");
                        return;
                    }
                    resolve(out);
                }
                else {
                    reject("Got a response from Coinbase but it was not OK");
                }
            })
                .catch(() => {
                // Everything failed: let's reject
                reject("Error while retrieving the token's price");
            });
        });
    });
}
exports.getNativeTokenPriceInUsd = getNativeTokenPriceInUsd;
/**
 * Returns the price of a given ERC20 token on a specific chain, expressed in USD.
 * @param tokenAddress The address of the ERC20 contract
 * @param chainId The ID of the chain that the price refers to
 * @returns The price of the given ERC20 token, expressed in USD
 */
async function getERC20TokenPriceInUSD(tokenAddress, chainId) {
    // Try to start Moralis and ignore errors
    try {
        await moralis_1.default.start({
            apiKey: exports.MORALIS_API_KEY,
        });
    }
    catch (e) { }
    const resolvedChain = moralis_1.default.EvmUtils.EvmChain.create(chainId);
    const response = await moralis_1.default.EvmApi.token.getTokenPrice({
        address: tokenAddress,
        chain: resolvedChain,
    });
    const usdPrice = response.toJSON()["usdPrice"];
    return Promise.resolve(usdPrice);
}
exports.getERC20TokenPriceInUSD = getERC20TokenPriceInUSD;
